import { PageErrorBoundary } from '@/components/error-boundaries/page-error-boundary'
import { UserManagementPage } from '@/routes/user-management/page'

export const UserManagement = () => (
  <PageErrorBoundary>
    <UserManagementPage />
  </PageErrorBoundary>
)
